/*
 * Basic file with global javascript.
 * Files imported here will be available on every page.
 */

import '../../utils/swiper';

import Alpine from 'alpinejs';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';

import '~/styles/main.css'; // tailwind

import React from 'react';
import { createRoot } from 'react-dom/client';
import CartDrawer from '../snippets/cart-drawer/cart-drawer';

/** Global Scripts */
import xOnShopify from '~js/alpine-plugins/x-on-shopify';
import { QuickAddProductSideDrawer } from '~js/bundles/snippets/side-drawer';
import Header from '../sections/header';
import Footer from '../sections/footer';
import MobileMenuOverlay from '../snippets/mobile-menuoverlay';
import { initPrimaryHeroSwiper } from '../sections/hero-primary';
import { handleQuickBuyClickGlobal } from '../snippets/quick-add-to-bag-global';

/** Product Detail Page Scripts */
import { QuickAddProductDrawerMobile } from '../snippets/pdp-mobile-drawer';

/** Components */
import { initCategoryTabScript } from '../sections/category-variation2';
import { initCategoryGrid } from '../sections/category-variation1';
import { initSocialFeedScript } from '../sections/social-feed';
import { testimonialsCarousel } from '../sections/customer-testimonial';
import { initTestimonialCarousel } from '../sections/featured-testimonial';
import { initProductGrid } from '../sections/product-grid-swiper';
import { initStartVideo, initVideoSwiper } from '../sections/trusted-by';
import { initWatchLearnCarousel } from '../sections/watch-learn';
import { initFaqAccordion } from '../sections/faq';
import { featureCallout } from '../sections/feature-callout';

/** Store locater drawer */
import { deliveryDrawer } from '../snippets/delivery-drawer';

/** Blogs & Articles */
// import BlogsSection from '../sections/blog';
// import BlogCarouselSection from '../sections/blogs-carousel-section';
// import BlogArchiveSection from '../sections/blog-archive-section';

/** Customer */
// import CustomerLogin from '../sections/customer-login';
import CustomerAccount from '../sections/customer-account';

// Global Config
window.globalConfig = {
  currency: window.Shopify?.currency?.active || 'USD',
  localeCode:
    window.Shopify?.locale && window.Shopify?.country
      ? `${window.Shopify.locale}-${window.Shopify.country}`
      : 'en-US',
};

/** Global Components */
QuickAddProductSideDrawer.initialize();
initPrimaryHeroSwiper();
initVideoSwiper();
initStartVideo();
initProductGrid();
featureCallout();
Footer.initializeEvents();
Header.initializeEvents();
MobileMenuOverlay.init();
initTestimonialCarousel();
initWatchLearnCarousel();
testimonialsCarousel();
handleQuickBuyClickGlobal();
QuickAddProductDrawerMobile.initialize();
initCategoryTabScript();
initCategoryGrid();
initSocialFeedScript();
initFaqAccordion();

/** Collection Components */

/** Blogs & Articles  */
// BlogsSection.init();
// BlogArchiveSection.init();
// BlogCarouselSection.init();

/** Store Draswer */
deliveryDrawer.initializeEvents();

/** Customer */
// CustomerLogin.init();
CustomerAccount.init();

/** React Components */
const reactAppsMapping = {
  'cart-drawer': CartDrawer,
};

document.addEventListener('DOMContentLoaded', () => {
  const path = window.location.pathname;
  if (
    path === '/blogs' ||
    path.startsWith('/blogs/') ||
    path === '/articles' ||
    path.startsWith('/articles/')
  ) {
    window.location.href = '/404';
  }

  const reactApps = document.querySelectorAll('.react-app-root');

  reactApps.forEach((container) => {
    const appId = container.id;
    const Component = reactAppsMapping[appId];

    if (Component) {
      const root = createRoot(container); // Create a root
      root.render(<Component />); // Render the component
    }
  });
});

Alpine.plugin(xOnShopify);

window.Alpine = Alpine;
Alpine.start();

// // BUGHERD
if (
  window.location.hostname !== '127.0.0.1' &&
  !window.Shopify.designMode &&
  window.Shopify.theme.role !== 'main'
) {
  const script = document.createElement('script');
  script.src =
    'https://www.bugherd.com/sidebarv2.js?apikey=czwfalkp21nfn9k6j07x4q';
  document.head.append(script);
}
